var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeaderBlanc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 713 788",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M713 0H110.578C-113.54 369.796 310.257 395.747 0 788h713V0z",
    fill: "#fff",
    fillOpacity: 0.59
  })));
}

export default __webpack_public_path__ + "05fd24208518a170a4a7e6a655658519.svg";
export { SvgHeaderBlanc as ReactComponent };